import React from 'react'
import {ModalBase} from '../ModalBase'
import CheckIcon from '../../../media/felsv/CheckIcon.svg'

const ModalEmitir = (props: any) => {
  return (
    <ModalBase Styles={props.Styles}>
      <div className='modal-card' style={{width: '100%'}}>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{props.title || "Emitir Factura"}</h3>
          </div>
          <div className='form-separator'></div>
          <p className='m'>{props.detail || "Estás a punto de emitir esta factura ¿deseas continuar?"}</p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={props.ClicCancelar}>
              <div>Cancelar</div>
            </button>
            <button className='m button w-inline-block' onClick={props.ClicEmitir}>
              <div>Emitir</div>
              <img src={CheckIcon} loading='lazy' alt='Emitir' />
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalEmitir
